export const environment = {
  production: true,
  environmentName: 'dev',
  apiGatewayURL: 'https://api.dev.hero.schoolmint.com/hero-v1'
};
